import React from "react";
import ArrowRightIcon from "./arrowrightIcon";
import ArrowLeftIcon from "./arrowleftIcon";
import { useNavigate } from "react-router-dom";

const NumberPagination = ({
  pagination,
  setCurrentPage,
  totalPages,
  path,
  filters = "",
}) => {
  const navigate = useNavigate();
  const handlePageChange = (value) => {
    if (value === "next") {
      setCurrentPage(pagination + 1);
      navigate(`${path}?page=${pagination + 1}${filters}`);
    } else if (value === "prev") {
      setCurrentPage(pagination - 1);
      navigate(`${path}?page=${pagination - 1}${filters}`);
    } else {
      setCurrentPage(value);
      navigate(`${path}?page=${value}${filters}`);
    }
  };

  const getPageNumbers = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    } else if (pagination <= 2) {
      return [1, 2, 3, 4, 5];
    } else if (pagination >= totalPages - 1) {
      return [
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }
    const startPage = pagination - 2;
    const endPage = pagination + 2;
    console.log(startPage);
    console.log(endPage);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="mx-4 my-2">
      <>
        {pagination && totalPages > 0 ? (
          <div className="d-flex align-items-center justify-content-end gap-2 mt-3">
            <span className=" content px-3 pt-1 mx-3">
              <span className=" Medium_Purple fw_700">{pagination}</span>/
              <span className="fw_700 ms-1">{totalPages}</span>
            </span>

            <div className="me-3 cursor_pointer" style={{ width: "28px" }}>
              <button
                disabled={pagination === 1 ? true : false}
                onClick={() => {
                  handlePageChange("prev");
                }}
                type="button"
                className="border-0 navigate-btn"
              >
                {pagination <= 1 ? (
                  <ArrowLeftIcon fill="#B0B3C7" width={12} height={12} />
                ) : (
                  <ArrowLeftIcon fill="#7065E4" width={12} height={12} />
                )}
              </button>
            </div>
            {pageNumbers.map((pageNumber) => (
              <button
                onClick={() => {
                  handlePageChange(pageNumber);
                }}
                key={pageNumber}
                className={`border-0  fs_16 cursor_pointer ${
                  pagination === pageNumber
                    ? "bg_color_E5ECFFB2 primary_color "
                    : "bg-transparent color_030304"
                }   fw_600 fs_18 px-3 rounded-2 py-1`}
                type="button"
              >
                {pageNumber ?? pageNumber}
              </button>
            ))}

            <div className="ms-3 cursor_pointer" style={{ width: "28px" }}>
              <button
                disabled={pagination === totalPages ? true : false}
                onClick={() => {
                  handlePageChange("next");
                }}
                className="border-0  navigate-btn"
                type="button"
              >
                {pagination >= totalPages ? (
                  <ArrowRightIcon fill="#B0B3C7" width={12} height={12} />
                ) : (
                  <ArrowRightIcon fill="#7065E4" width={12} height={12} />
                )}
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    </div>
  );
};

export default NumberPagination;
